import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "semantic-ui-react"
import shop from "shop/shop"
import { observer } from "mobx-react"
import { trackAddToWishlist } from "components/tracking/Tracking";

@observer
class ButtonLove extends Component {
  
  state = {
    list: false
  }
  
  handleClick = async () => {
    const { product } = this.props
    const useV2 = shop.config.plugin && shop.config.plugin.MerklisteV2

    if ( useV2 ) {
      const storeV2 = shop.store.orderlistV2
      if ( storeV2 && storeV2.currentList ) {
        storeV2.currentList.toggle( product )
        storeV2.currentList.save()
        return
      }
      trackAddToWishlist( product.map_id, product.title )
      storeV2 && storeV2.toggleSelectionModal( product )
    } else {
      if ( shop.orderlist && shop.orderlist.lists && shop.orderlist.lists.Standard
           && shop.store.orderlist.currentList == false ) {
        await shop.store.orderlist.setCurrentList( shop.orderlist.lists.Standard )
      }
      if ( shop.store.orderlist.currentList && product ) {
        shop.store.orderlist.currentList.toggle( product )
        shop.store.orderlist.currentList.save()
        return
      }
      trackAddToWishlist( product.map_id, product.title )
      shop.store.orderlist.toggleSelectionModal( product )
    }
  }

  render() {
    const useV2     = shop.config.plugin && shop.config.plugin.MerklisteV2
    const currentList = useV2
      ? (shop.store.orderlistV2 ? shop.store.orderlistV2.currentList : null)
      : shop.store.orderlist.currentList
    const { items } = currentList || {}
    const { list } = this.state
    let { as, product, children, elementActive, elementInActive } = this.props
    if ( !elementActive ) elementActive = children
    if ( !elementInActive ) elementInActive = children
    
    let onList = items && items.get( product.map_id )
    // let activeClass = (list.contains( product ) ? "active" : false)
    let activeClass = ""
    if ( onList ) {
      activeClass = "active"
    }
    let {  circular = true, basic = true, ...rest } = this.props
  
    if ( as ) {
      let Element = as
      return <Element
        className={`${this.props.className} ${activeClass}`}
        onClick={this.handleClick}
        {...rest} >{activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</Element>
    }
    
    return (
      <Button style={{border: "none", backgroundColor: "transparent"}}
        className={`btn-love ${activeClass} ${this.props.className}`}
        onClick={this.handleClick}>
        {activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</Button>)
  }
}

ButtonLove.propTypes = {
  product: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
  children: PropTypes.any,
  elementActive: PropTypes.any,
  elementInActive: PropTypes.any,
}

export default ButtonLove



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Button/ButtonLove.js